import script from "./PointChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PointChart.vue?vue&type=script&setup=true&lang=js"

import "./PointChart.vue?vue&type=style&index=0&id=4c734b14&lang=less"

const __exports__ = script;

export default __exports__